/* eslint-disable sonarjs/null-dereference -- rule treats `string` parameters as possibly null (false positive) */
function hasAsciiWhitespaceOrControl(value: string): boolean {
	for (let i = 0; i < value.length; i += 1) {
		const unit = value.charCodeAt(i);
		if (unit <= 32 || unit === 0xa0) {
			return true;
		}
	}
	return false;
}

export function isBasicEmailShape(email: string): boolean {
	if (email.length === 0 || hasAsciiWhitespaceOrControl(email)) {
		return false;
	}
	const at = email.indexOf("@");
	if (at <= 0) {
		return false;
	}
	const domain = email.slice(at + 1);
	const dot = domain.indexOf(".");
	return dot > 0 && dot < domain.length - 1;
}
/* eslint-enable sonarjs/null-dereference */
